import userManager from "emun.auth/users/user-manager";
import userManagerDependent from "emun.auth/users/user-manager-dependent";
import userEditor from "emun.auth/users/user-editor";
import userFieldset from "emun.auth/users/user-fieldset";
import userCalendarAuth from "emun.auth/users/user-calendar-auth";
import userCalendarToken from "emun.auth/users/user-calendar-token";

export default mod =>
  mod
    .component("userManager", userManager)
    .component("userManagerDependent", userManagerDependent)
    .component("userEditor", userEditor)
    .component("userFieldset", userFieldset)
    .component("userCalendarAuth", userCalendarAuth)
    .component("userCalendarToken", userCalendarToken).name;
